import { apiV2 } from './http';
import type {
  CreateGroupCampaignPayload,
  CreateStoreGroupPayload,
  GroupCampaignResponse,
  StoreGroup,
  StoreGroupDetail,
  StoreGroupInstallation,
  UpdateGroupCampaignPayload,
} from './interfaces/storeGroup';

const BASE_PATH = 'store-groups';

export async function listStoreGroups(): Promise<StoreGroup[]> {
  const res = await apiV2.get<{ groups: StoreGroup[] }>(BASE_PATH);
  return res.data.groups;
}

export async function createStoreGroup(
  payload: CreateStoreGroupPayload,
): Promise<StoreGroup> {
  const res = await apiV2.post<{ group: StoreGroup }>(BASE_PATH, payload);
  return res.data.group;
}

export async function renameStoreGroup(
  id: number,
  name: string,
): Promise<void> {
  await apiV2.put(`${BASE_PATH}/${id}`, { name });
}

export async function deleteStoreGroup(
  id: number,
  confirm?: boolean,
): Promise<void> {
  await apiV2.delete(`${BASE_PATH}/${id}`, { data: { confirm } });
}

export async function getStoreGroupDetail(
  id: number,
): Promise<StoreGroupDetail> {
  const res = await apiV2.get<StoreGroupDetail>(`${BASE_PATH}/${id}`);
  return res.data;
}

export async function updateStoreGroupCampaign(
  storeGroupId: number,
  payload: UpdateGroupCampaignPayload,
): Promise<GroupCampaignResponse> {
  const res = await apiV2.patch<{ data: GroupCampaignResponse }>(
    `${BASE_PATH}/${storeGroupId}/campaign`,
    payload,
  );
  return res.data.data;
}

export async function listStoreGroupInstallations(
  storeGroupId: number,
): Promise<StoreGroupInstallation[]> {
  const res = await apiV2.get<{ installations: StoreGroupInstallation[] }>(
    `${BASE_PATH}/installations`,
    { params: { store_group_id: storeGroupId } },
  );
  return res.data.installations;
}

export async function addStoreGroupInstallations(
  storeGroupId: number,
  idis: number[],
): Promise<void> {
  await apiV2.post(`${BASE_PATH}/installations`, {
    store_group_id: storeGroupId,
    idis,
  });
}

export async function removeStoreGroupInstallations(
  storeGroupId: number,
  idis: number[],
): Promise<void> {
  await apiV2.delete(`${BASE_PATH}/installations`, {
    data: { store_group_id: storeGroupId, idis },
  });
}

export async function createStoreGroupCampaign(
  storeGroupId: number,
  payload: CreateGroupCampaignPayload,
): Promise<GroupCampaignResponse> {
  const res = await apiV2.post<{ data: GroupCampaignResponse }>(
    `${BASE_PATH}/${storeGroupId}/campaign`,
    payload,
  );
  return res.data.data;
}
